module.exports = __webpack_public_path__ + "static/media/partner_desktop.65fa43f0.jpg";